module.exports = __webpack_public_path__ + "static/media/brand12.e2a77b63.png";